/**
 * @generated SignedSource<<aaf62f054703089ce99c9d576dad1bd1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HtmlConfigCard_brand$data = {
  readonly appConfig: {
    readonly htmlCustomAttributes: ReadonlyArray<{
      readonly attributeKey: string;
      readonly attributeValue: string;
      readonly querySelector: string;
    }> | null;
    readonly id: string;
  };
  readonly id: string;
  readonly " $fragmentType": "HtmlConfigCard_brand";
};
export type HtmlConfigCard_brand$key = {
  readonly " $data"?: HtmlConfigCard_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"HtmlConfigCard_brand">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HtmlConfigCard_brand",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandAppConfigType",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "HTMLCustomAttribute",
          "kind": "LinkedField",
          "name": "htmlCustomAttributes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "querySelector",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "attributeKey",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "attributeValue",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};
})();

(node as any).hash = "7c87e97097b8ac32733920a957c36ff0";

export default node;
